import React from "react";
import { Container, Row, Col, Card, ListGroup, Button } from "react-bootstrap";
import bannerImg from "../Assets/Image/subassebts1.jpg";
import assemblyImg from "../Assets/Image/subassemblytrunking.jpg";
import assemblyImg1 from "../Assets/Image/assemblyImg1.jpeg";
import assemblyImg2 from "../Assets/Image/assemblyImg2.jpeg";
import assemblyImg3 from "../Assets/Image/assemblyImg3.jpeg";
import assemblyImg4 from "../Assets/Image/assemblyImg4.jpeg";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Helmet } from "react-helmet";

const SubAssembliesBusbartrunking = () => {
  const navigate = useNavigate();

  const products = [
    { name: " Contact Assembly for Tap Off Boxes", image: assemblyImg1 },
    {
      name: "Standard Joint Packs and Special Joint Packs",
      image: assemblyImg2,
    },
    { name: "Rubber Bellow Expansion Joints", image: assemblyImg3 },
    { name: "IP 68 and IP65 Busbar assembly", image: assemblyImg4 },
  ];

  return (
    <div>
      <Helmet>
        <title>Sub Assemblies - Busbar Trunking | Delta Engineering</title>
        <meta
          name="description"
          content="Engineered sub-assemblies for busbar trunking systems, designed for reliable, space-efficient, and maintenance-friendly power distribution in industrial and commercial infrastructures."
        />
        <meta
          name="keywords"
          content="Busbar Trunking Sub Assemblies, Busbar System Components, Tap Off Box Assemblies, Joint Packs, Rubber Bellow Expansion Joints, Copper Busbar, Aluminum Busbar, IEC 61439 Compliant Busbar"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Sub Assemblies - Busbar Trunking" />
        <meta
          property="og:description"
          content="High-performance sub-assemblies for busbar trunking systems, offering high current capacity, modular design, and reliable power distribution for industrial and commercial infrastructures."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.yourdomain.com/sub-assemblies-busbar-trunking"
        />
        <meta
          property="og:image"
          content="https://www.yourdomain.com/images/sub-assemblies-busbar-trunking.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Sub Assemblies - Busbar Trunking | Delta Engineering"
        />
        <meta
          name="twitter:description"
          content="Busbar trunking sub-assemblies engineered for safety, efficiency, and easy maintenance. Widely used in industrial plants, data centers, high-rise buildings, and power substations."
        />
        <meta
          name="twitter:image"
          content="https://www.yourdomain.com/images/sub-assemblies-busbar-trunking.jpg"
        />
      </Helmet>

      <section className="productbanner1 d-flex align-items-center position-relative">
        <div className="overlay-layer"></div>
        <Container className="text-center position-relative z-2">
          <Row className="justify-content-center">
            <Col lg={8} className="hero-content text-center">
              <h2
                className="hero-title"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
               <span className="blue-text">Sub Assemblies - </span>{" "}
            <span className="white-text">Busbar Trunking</span>
              </h2>
              <p
                className="hero-subtitle"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                Reliable, compact, and low-maintenance sub-assemblies for busbar trunking systems.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="py-3" style={{ position: "relative" }}>
        <Button onClick={() => navigate("/ourproducts")} className="back-btn">
          <IoMdArrowRoundBack className="back-icon" />
          Back
        </Button>
        <Container>
          <Row className="text-center mb-4">
            <Col>
              <h3 className="fw-bold section-title">
                Sub Assemblies - Busbar Trunking
                <span className="title-underline"></span>
              </h3>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col md={4} data-aos="fade-zoom-in" data-aos-delay="200">
              <img
                src={bannerImg}
                alt="Busbar Trunking System"
                className="img-fluid rounded shadow"
                style={{
                  maxHeight: "350px",
                  width: "500px",
                  objectFit: "fill",
                  borderRadius: "8px",
                }}
              />
            </Col>
            <Col md={8} data-aos="fade-zoom-in" data-aos-delay="200">
              <p>
                Busbar trunking systems are modern electrical power distribution
                systems that offer superior safety, efficiency, and space-saving
                benefits compared to traditional cabling. These are extensively
                used in industrial and commercial applications where high
                reliability and scalability are essential.
              </p>
              <p>
                Our sub-assemblies for busbar trunking are designed for seamless
                integration into both horizontal and vertical distribution
                networks. These components are manufactured with precision to
                ensure mechanical robustness, electrical continuity, and heat
                resistance under varying load conditions.
              </p>
              <p>
                With modular construction and standardized designs, our
                solutions help reduce on-site installation time and ensure easy
                maintenance, making them ideal for critical infrastructure such
                as data centers, factories, high-rise buildings, and power
                plants.
              </p>
            </Col>
          </Row>

          <h2 className="text-center fw-bold mb-4">Related Products</h2>
          <Row className="g-4 mb-5 ">
            {products.map((product, index) => (
              <Col key={index} xs={12} sm={6} md={4} lg={3}>
                <Card className="h-100 shadow-sm border-0 text-center">
                  <Card.Img
                    variant="top"
                    src={product.image}
                    alt={product.name}
                    style={{
                      height: "180px",
                      objectFit: "contain",
                      padding: "10px",
                    }}
                  />
                  <Card.Body>
                    <Card.Title className="text-muted fs-6">
                      {product.name}
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <Row className="align-items-center py-5">
            <Col md={8} data-aos="fade-zoom-in" data-aos-delay="200">
              <h4 className="mb-3">Seamless Integration in Busbar Systems</h4>
              <p>
                The image showcases a typical high-quality sub-assembly used in
                modern busbar trunking systems. These systems are designed to
                efficiently distribute power across vertical and horizontal
                installations without compromising performance.
              </p>
              <p>
                Our assemblies integrate top-tier insulation, connectors, and
                safety mechanisms to ensure long-term durability and compliance
                with international electrical standards.
              </p>
              <p>
                Every part is tested rigorously to minimize loss, overheating,
                and ensure system-wide synchronization during power loads and
                fluctuations.
              </p>
            </Col>
            <Col md={4} data-aos="fade-zoom-in" data-aos-delay="200">
              <img
                src={assemblyImg}
                alt="Busbar Trunking Assembly"
                className="img-fluid rounded shadow"
              />
            </Col>
          </Row>

          <Row className="mb-5">
            <Col data-aos="fade-up">
              <h4 className="mb-3">Key Features</h4>
              <ul>
                <li>High current-carrying capacity with low power loss</li>
                <li>Customizable length and connection terminals</li>
                <li>
                  Corrosion-resistant materials with long operational life
                </li>
                <li>Compact design for efficient space utilization</li>
                <li>
                  Pre-tested for safety, conductivity, and thermal performance
                </li>
              </ul>
            </Col>
          </Row>

          <Row className="mb-5">
            <Col md={6} data-aos="fade-zoom-in" data-aos-delay="200">
              <h4 className="mb-3">Technical Specifications</h4>
              <Card className="shadow-sm">
                <ListGroup variant="flush">
                  <ListGroup.Item>
                    <strong>Material:</strong> Copper/Aluminum with insulation
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Rated Current:</strong> 400A to 6300A
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Insulation:</strong> Mylar
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Operating Temperature:</strong> -25°C to +105°C
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Finish:</strong> Tin/ Silver/ Bare
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Compliance:</strong> IEC 61439, RoHS, ISO Certified
                  </ListGroup.Item>
                </ListGroup>
              </Card>
            </Col>

            <Col md={6} data-aos="fade-zoom-in" data-aos-delay="200">
              <h4 className="mb-3">Applications</h4>
              <ul>
                <li>Industrial Plants & Automation Lines</li>
                <li>Data Centers and IT Hubs</li>
                <li>High-rise Buildings and Commercial Complexes</li>
                <li>Renewable Energy Installations</li>
                <li>Power Substations and Distribution Panels</li>
              </ul>
            </Col>
          </Row>

          <Row>
            <Col className="text-center" data-aos="zoom-in">
              <h5>Need Custom Solutions?</h5>
              <p>
                We offer customized busbar trunking systems to suit your exact
                requirements. Contact us for more details.
              </p>
              <a href="/contact" className="btn btn-outline-primary mt-2 px-4">
                Contact Us
              </a>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default SubAssembliesBusbartrunking;
